<template>
  <PageSecondary>
    <template #title>Настоящее</template>

    <div style="margin-top: 24px;">
      <div style="display: flex; flex-direction: row; justify-content: space-between">
        <img src="../assets/photo/arch/1@s.jpg">
        <img src="../assets/photo/arch/2@s.jpg">
        <img src="../assets/photo/arch/3@s.jpg">
      </div>
      <div style="display: flex; flex-direction: row; justify-content: space-between; margin-top: 4px;">
        <img src="../assets/photo/arch/6@s.jpg">
        <img src="../assets/photo/arch/5@s.jpg">
        <img src="../assets/photo/arch/4@s.jpg">
      </div>
      <div class="after-photos">
        Изучаю архитектуру. Планирую построить город. Я начал со светильника, продолжу своим домом, потом небольшой
        резорт на природе,
        деревня и город.
      </div>
    </div>

    <div style="margin-top: 24px;">
      <div style="display: flex; flex-direction: row; justify-content: space-between">
        <img src="../assets/photo/city/1@s.jpg">
        <img src="../assets/photo/city/2@s.jpg">
        <img src="../assets/photo/city/3@s.jpg">
      </div>
      <div style="display: flex; flex-direction: row; justify-content: space-between;margin-top: 4px;">
        <img src="../assets/photo/city/4@s.jpg">
        <img src="../assets/photo/city/5@s.jpg">
        <img src="../assets/photo/city/6@s.jpg">
      </div>
      <div class="after-photos">
        Люблю сочетание природы, бетона и технологий. Работаю и треню в сити, вид сверху настраивает на глобальное
        видение.
      </div>
    </div>

    <div style="margin-top: 24px;">
      <div style="display: flex; flex-direction: row; justify-content: space-between">
        <img src="../assets/photo/moto/2@s.jpg">
        <img src="../assets/photo/moto/3@s.jpg">
        <img src="../assets/photo/moto/1@s.jpg">
      </div>
      <div class="after-photos">
        У меня рыжий Лисёныш Yamaha MT-09. Это удобная парковка, пробки в 3 раза быстрее, небо над головой.
      </div>
    </div>

    <div style="margin-top: 24px;">
      <div style="display: flex; flex-direction: row; justify-content: space-between">
        <img src="../assets/photo/piano/2@s.jpg">
        <img src="../assets/photo/piano/3@s.jpg">
        <img src="../assets/photo/piano/1@s.jpg">
      </div>
      <div class="after-photos">
        Играю на фортепьяно
      </div>
    </div>


  </PageSecondary>
</template>

<script>
import PageSecondary from "@/components/PageSecondary";

export default {
  name: "Present",
  components: {PageSecondary}
}
</script>

<style scoped>
img {
  object-fit: cover;
  width: 130px;
  height: 130px;
  max-width: 33%;
}

.after-photos {
  margin-top: 8px;
}
</style>
